/*
  Murlong Cres — relabel the Globo Pre-Order "Save 15%" badge to
  "Pre-order and save 15%". The percent stays dynamic (the app fills it in).

  Done in the theme because the app's label ("Save") isn't editable in its
  settings. Re-applies whenever the app re-renders the badge (variant / payment
  change). Idempotent: once the text starts with "Pre-order" the regex no longer
  matches, so it never doubles up. Uses setTimeout (not requestAnimationFrame,
  which pauses in background tabs) plus timed retries to catch the app's async
  first render.
*/
(function () {
  var FIND = /^\s*Save\b/;
  var REPLACEMENT = 'Pre-order and save';

  function relabel() {
    var badges = document.querySelectorAll('.gPreorderSaleBadge');
    for (var i = 0; i < badges.length; i++) {
      var text = badges[i].textContent;
      if (FIND.test(text)) badges[i].textContent = text.replace(FIND, REPLACEMENT);
    }
  }

  var timer = null;
  function schedule() {
    if (timer) return;
    timer = setTimeout(function () { timer = null; relabel(); }, 50);
  }

  function start() {
    relabel();
    setTimeout(relabel, 400);
    setTimeout(relabel, 1200);
    setTimeout(relabel, 2500);
    if (window.MutationObserver && document.body) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
